export default function getVolumeViewReferenceId(args) {
    const { sliceIndex, viewPlaneNormal, volumeId } = args;
    const querySeparator = volumeId.includes('?') ? '&' : '?';
    const formattedNormal = viewPlaneNormal.map((value) => value.toFixed(3));
    return `volumeId:${volumeId}${querySeparator}sliceIndex=${sliceIndex}&viewPlaneNormal=${formattedNormal.join(',')}`;
}
